<template>
    <div class="smiths-chart-card">
        <div class="smiths-chart-card__header">
            <span class="smiths-chart-card__title">{{ title }}</span>
        </div>
        <div class="smiths-chart-card__body">
            <div v-if="$slots.sidebar" class="smiths-chart-card__sidebar">
                <slot name="sidebar" />
            </div>
            <div class="smiths-chart-card__chart">
                <chart-loading-skeleton v-if="loading" />
                <empty-widget-state v-else-if="!hasData" :text="emptyText" />
                <slot v-else />
            </div>
        </div>
    </div>
</template>

<script setup>
import ChartLoadingSkeleton from '@/Pages/DashboardV2/Components/ChartLoadingSkeleton.vue';
import EmptyWidgetState from '@/Pages/DashboardV2/Components/EmptyWidgetState.vue';

defineProps({
    title: {
        type: String,
        required: true,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    hasData: {
        type: Boolean,
        default: true,
    },
    emptyText: {
        type: String,
        default: 'No data available for this period.',
    },
});
</script>

<style scoped>
.smiths-chart-card {
    background: var(--cui-card-bg, #fff);
    border: 1px solid var(--cui-card-border-color, #d8dbe0);
    border-radius: 0.375rem;
    overflow: hidden;
}

.smiths-chart-card__header {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid var(--cui-card-border-color, #d8dbe0);
    font-weight: 600;
}

.smiths-chart-card__body {
    display: flex;
    min-height: 250px;
}

.smiths-chart-card__sidebar {
    flex-shrink: 0;
    width: 180px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    border-right: 1px solid var(--cui-card-border-color, #d8dbe0);
}

.smiths-chart-card__chart {
    flex: 1;
    padding: 1rem;
    min-width: 0;
}

@media (max-width: 768px) {
    .smiths-chart-card__body {
        flex-direction: column;
    }

    .smiths-chart-card__sidebar {
        width: 100%;
        flex-direction: row;
        flex-wrap: wrap;
        border-right: none;
        border-bottom: 1px solid var(--cui-card-border-color, #d8dbe0);
    }
}
</style>
